import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { IItem } from '@coreui/angular-pro'
import { GenericResponse, InvitationData } from 'src/app/interfaces/apiresponses'; 
import { RestService } from 'src/app/services/rest/rest.service';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TableUtil } from 'src/app/shared/utils/table.util';
import { single } from 'rxjs';
@Component({
  selector: 'app-invitation-list',
  templateUrl: './invitation-list.component.html',
  styleUrls: ['./invitation-list.component.scss'],
  providers:[DatePipe]
})
export class InvitationListComponent {
  invitationForm!: FormGroup
   // Alert buttons
   bAlert = false
   alertHeaderText = ""
   alertBodyText = ""
   bShowSecondAlertButton = false
   alertSecondButtonText = ""
   alertCloseButtonText = "Close"
   alertBoxData: any;
   vvvv:any
   serviceData: IItem[] = []
   selectedItems = [2, 3];
  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  columns = [
    {
      key: 'invitationChannel',
      label: 'InvitationChannel',
      _cellProps: {align: 'middle'},
      filter: true      
    },
    {
      key: 'name',
      label: 'Name',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'emailId',
      label: 'Email ID',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'mobileNumber',
      label: 'Mobile',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'sourceOfIncome',
      label: 'Source Of Income',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'status',
      label: 'Onboarding Status',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'createdOn',
      label: 'Created Date',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'expriesOn',
      label: 'Expire Date',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'invitationCode',
      label: 'InvitationCode',
      _cellProps: {align: 'middle'},
      filter: true      
    },
    {
      key: 'isUsed',
      label: 'Invitation Status',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'img',
      label: 'QR Code',
      _cellProps: {align: 'middle'},
      filter: false
    },
    // {
    //   key: 'Action',
    //   label: 'Action',
    //   _cellProps: {align: 'middle'},
    //   filter: false
    // }
  ];
  getRoleBadge(item: any){
    if (item.isUsed) {
     return 'primary'
    } else {
      return 'danger'
    }
  }
  getRole(item: any){
    if (item.isUsed) {
      
        return 'Used'
     
    } else {
      return 'Unused'
    }
  }
  ngOnInit() {
    this.invitationForm = new FormGroup({
      isSingleDetailedInvitation: new FormControl("", [Validators.required]),
      //isRejected: new FormControl("0", [Validators.required]),
      ddlInvitationStatus:new FormControl("0", [Validators.required])

    })
  }
  rowSelected = (clickedItem: any) => {}
  onAlertButtonClick(event: any){
    this.bAlert = event.state
  }
  closeAlert(event: any){
    this.bAlert = event.state
  }
  alertVisibility(event: any) {
    this.bAlert = event.state
  }
  constructor(private restApi: RestService, 
    private changeDetector: ChangeDetectorRef,
    private datePipe: DatePipe
  ){
///this.getAllInvitation()
  } 

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  usersData: IItem[] = []



  selectValue:any;
  selectType(event:any){
    console.log(event)
   this.selectValue = event
     
  }
  Color(item:any){
    return 'btn btn-primary'
  }
  // downloadReport(){
  //   let type= "";

  //   if(this.invitationForm?.value?.isSingleDetailedInvitation === 1){
  //      type= "Single";
  //   }else{
  //      type= "Multiple";
  //   }

  //   if (TableUtil.exportTableToExcel("auditReportTable",type))
  //     this.showAlertBox('Downloaded', 'The report is downloaded. Please look for the report in your browser download section.')
  //   else
  //     this.showAlertBox('Sorry', 'Unable to download the report. Please contact technical support.')
  // }
  submit(){
    console.log(this.invitationForm.value.isRejected)
     if(this.invitationForm.value?.isSingleDetailedInvitation === "null" || this.invitationForm.value?.isSingleDetailedInvitation === "" ){
      this.showAlertBox('Sorry', 'Please select Invitation Type.')
      return
     }
    //  if(this.invitationForm.value?.isRejected === "null" || this.invitationForm.value?.isRejected === "" ){
    //   this.showAlertBox('Sorry', 'Please select Status.')
    //   return
    //  }
      let payload = {
        "invitationType": this.invitationForm?.value?.isSingleDetailedInvitation,
        "invitationStatus": Number(this.invitationForm?.value?.ddlInvitationStatus)
      }
      
        this.restApi.getAllInvitation(payload).subscribe({
          next: (v: InvitationData) => {
            this.serviceData = v.data.map((item, Reference) => {            
              const _selected = this.selectedItems.includes(Reference);
              let nameValue = item?.name !== null ? item?.name.substring(0, 20) + "..." : 'N/A'
              return {
                ...item,
                _selected,
                name:nameValue,
                img:item.base64QRCode == '' ?'' : 'data:image/png;base64, '+item.base64QRCode
              };
            })
          },
          error: (e) => {}
        })
    }
}
